export const ALLOWED_IMAGE_VIDEO_FORMATS = ["png", "jpeg", "jpg", "mp4"];
export const ALLOWED_AUDIO_FORMATS = ["mp3", "aac", "wav"];
export const AUDIO_VIDEO_FORMATS = ["mp3", "aac", "wav", "mp4"];
export const ALLOWED_DOCUMENT_FORMATS = [
  "doc",
  "docx",
  "pdf",
  "xls",
  "xlsx",
  "txt",
  "csv",
  "ppt",
  "pptx",
  "zip",
  "rar"
];

export const IMAGE_FORMATS = ["image/png", "image/jpeg", "image/jpg"];
export const AUDIO_FORMATS = ["audio/mp3", "audio/wav", "audio/mpeg", "audio/ogg", "audio/aac", "audio/vnd.dlna.adts"];
export const VIDEO_FORMATS = ["video/mp4"];
export const DOCUMENT_FORMATS = [
  "application/pdf",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "text/plain",
  "text/csv",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/zip",
  "application/x-zip-compressed",
  "application/rar",
  "application/vnd.rar",
  "application/excel",
  "application/x-excel",
  "application/x-msexcel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation"
];
export const ALLOWED_ALL_FILE_FORMATS = [
  "jpg",
  "jpeg",
  "png",
  "mp3",
  "wav",
  "aac",
  "mpeg",
  "mp4",
  "doc",
  "docx",
  "pdf",
  "xls",
  "xlsx",
  "txt",
  "csv",
  "ppt",
  "zip",
  "rar",
  "pptx",
  "acc"
];
export const CHAT_IMAGES = "chatimages";
export const CHAT_AUDIOS = "chataudios";

export const MAX_WIDTH_WEB = 330;
export const MIN_WIDTH_WEB = 240;
export const MAX_HEIGHT_WEB = 338;
export const MIN_HEIGHT_WEB = 83;

export const MAX_WIDTH_AND = 250;
export const MIN_WIDTH_AND = 210;
export const MAX_HEIGHT_AND = 320;
export const MIN_HEIGHT_AND = 80;

export const MIN_OFFSET_WIDTH = 280;
export const MIN_OFFSET_HEIGHT = 280;

export const MIN_THUMB_WIDTH = 322;

export const PREVIEW_MEDIA_TYPES = ["image", "video", "audio","file"];
export const MEDIA_MESSAGE_TYPES = ["image", "video", "audio", "file"];
export const INITIAL_LOAD_MEDIA_LIMIT = 20;
export const LOAD_MORE_MEDIA_LIMIT = 10;
export const CAPTION_CHARACTER_LIMIT = 1024;
export const ALLOWED_KEY_CODES = [8, 35, 36, 37, 38, 39, 40, 46, 65, 67, 86];
export const TYPE_DELAY_TIME = 5000;
export const CHAT_HISTORY_LIMIT = 20;

export const CONNECTED = "CONNECTED";
export const INLINE_FLEX = "inline-flex";
export const INVALID_STORENAME = "store name is not mentioned";
export const NO_INTERNET = "Please check your Internet connection";
export const RECONNECT_GET_CHAT_LIMIT = 50;
export const NO_INTERNET_TOAST = "Make sure your computer has active internet connection";
export const PROFILE_UPDATE_SUCCESS = "Profile updated successfully";
export const INITIALS_COLOR_CODES = [
  "#9068BE",
  "#E62739",
  "#845007",
  "#3A4660",
  "#1D1E22",
  "#A55A44",
  "#005995",
  "#600473",
  "#CD5554",
  "#00303F",
  "#BE4F0C",
  "#35A998",
  "#FC4A1A",
  "#368CBF",
  "#7EBC59",
  "#201D3A",
  "#1C8CB9",
  "#737272",
  "#237107",
  "#52028E",
  "#AF0D74",
  "#5BA672",
  "#0DAFA4",
];

export const BG_COLOR_CODES =
{
  "#9068BE": "#E8D4FF",
  "#E62739": "#FFD4D8",
  "#845007": "#FFEED5",
  "#3A4660": "#D3E1FF",
  "#1D1E22": "#D2DBFF",
  "#A55A44": "#FFDDD4",
  "#005995": "#D2EDFF",
  "#600473": "#F8D4FF",
  "#CD5554": "#FFD3D3",
  "#00303F": "#D4F5FF",
  "#BE4F0C": "#FFE3D3",
  "#35A998": "#D4FFF9",
  "#FC4A1A": "#FFDCD3",
  "#368CBF": "#D2EEFF",
  "#7EBC59": "#E3FFD3",
  "#201D3A": "#D8D3FF",
  "#1C8CB9": "#D2F2FF",
  "#737272": "#E8E8E8",
  "#237107": "#DFFFD4",
  "#52028E": "#ECD4FF",
  "#AF0D74": "#FFD4EF",
  "#5BA672": "#D4FFE1",
  "#0DAFA4": "#D3FFFC",
};
